import apiService from "./apiService";
import AppConstants from "../appConstants";

class AttendanceService {
    
    attendance(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ATTENDANCE, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    publicAttendance(form, params) {
        return new Promise((resolve, reject) => {
            apiService.post(AppConstants.URL_ATTENDANCE_PUBLIC, form, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}

export default new AttendanceService();
